export default __webpack_public_path__ + "static/media/08062cdfb323fb064ba713733ddb415d.png";